module.exports = __webpack_public_path__ + "static/media/BITI.59e1fefd.png";